/**
 * Core de admin-system
 *
 * Re-exporta guards e interceptors del monorepo y agrega
 * cualquier proveedor o token específico de esta aplicación.
 *
 * Uso: importar desde '@admin-system/core' (alias local) o
 * con ruta relativa desde app.routes.ts / app.config.ts
 */

// Guards
export { authGuard, publicOnlyGuard } from '@shared-data-access';
